const state = {
  dataDashboard: {},
  dataUserEpay: {},
  listSnapTransaksi: [],
  durasi: 0,
  mesinBerjalan: 0,
  dataOutlet: {},
};

export default state;
